"use client";

import { useEffect, useState } from "react";

export default function Markdown({
  children,
  as: _as = "div",
  sanitize = true,
  isBrand,
  ...rest
}: {
  children: string;
  as?: string;
  [key: string]: any;
  isBrand?: boolean;
}) {
  const [html, setHtml] = useState("");

  useEffect(() => {
    let cancelled = false;
    void import("./markdownProcessor").then(({ processMarkdown }) => {
      if (cancelled) return;
      setHtml(
        processMarkdown(typeof children === "string" ? children : "", {
          sanitize,
          isBrand,
        })
      );
    });
    return () => {
      cancelled = true;
    };
  }, [children, sanitize, isBrand]);

  const As: any = _as || "div";
  return (
    <As
      dangerouslySetInnerHTML={{
        __html: html,
      }}
      {...rest}
    />
  );
}
